import React, { useEffect } from "react";
import CloseIcon from "../../assets/img/common/close-gray-icon.jpg";
import { useRef } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";

import { Oval } from "react-loader-spinner";

// Define the ConfirmPopup component
const ConfirmPopup = ({
  title = "Confirm",
  description = () => <span>Are you sure you want to proceed</span>,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading,
  show,
  setShow,
  isDelete,
}) => {
  // Close modal and disconnect wallet
  const handleClose = () => {
    setShow(false);
  };

  // Ref for modal and handle outside click
  const modalRef = useRef(null);
  useOutsideClick(modalRef, handleClose, null, show);

  // Effect to control body overflow based on modal visibility
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  return (
    <div className="min-w-[100vw] w-full h-screen flex justify-center items-center bg-[#241b4795] backdrop-blur-md fixed top-0 left-0 z-50 roboto-font">
      <div
        ref={modalRef}
        className="w-11/12 md:w-[450px] flex flex-col items-center pb-10 pt-1 rounded-3xl bg-white"
      >
        <div className="w-full flex justify-end py-3 px-4">
          <button onClick={handleClose}>
            <img src={CloseIcon} alt="CloseIcon" />
          </button>
        </div>
        <span className="text-3xl font-semibold abel-font mt-1 ">{title}</span>
        <span className="text-[#464646] text-lg mt-4 px-5 text-center">
          {description()}
        </span>{" "}
        <div className="flex mt-7 w-11/12 md:w-9/12 justify-between items-center gap-3">
          <button
            onClick={handleClose}
            className={
              "w-1/2 flex justify-center items-center text-custom-gray-700 h-12 rounded-[10px] self-start font-medium border-2 border-custom-gray-700 hover:bg-custom-gray-700 hover:text-white box-border"
            }
          >
            {cancelText}
          </button>
          <button
            disabled={loading}
            onClick={onConfirm}
            className={`w-1/2 text-white flex justify-center items-center h-12 hover:ring-offset-2 rounded-[10px] disabled:opacity-70 ${
              isDelete ? "bg-red-500" : "bg-light-primary"
            }`}
          >
            {loading ? (
              <Oval
                height={25}
                width={25}
                color="#ffffff"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#ffffff"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPopup;
